'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.republishMessage = republishMessage;

var _getCurrentChannel = require('../../selectors/conversationSelectors/getCurrentChannel');

var _getCurrentThreadId = require('../../selectors/conversationSelectors/getCurrentThreadId');

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _setThreadId = require('conversations-schema/pubnub-message/operators/setThreadId');

var _publishMessage = require('../../pubsub/actions/publishMessage');

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

function republishMessage(message) {
  return function (dispatch, getState) {
    var channel = (0, _getCurrentChannel.getCurrentChannel)(getState());
    var threadId = (0, _getCurrentThreadId.getCurrentThreadId)(getState());
    var updatedMessage = (0, _buildUnpublishedMessage.buildUnpublishedMessage)((0, _setThreadId.setThreadId)(threadId, message));
    dispatch((0, _publishMessage.publishMessage)({ channel: channel, message: updatedMessage }));
    dispatch((0, _trackInteraction.trackInteraction)('republish-message'));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/PublishActions/republishMessage.js
// module id = 213
// module chunks = 2 3